<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Vue2 file: wwwroot\js\components\LeadFormLinks\FinanceLink\FinanceLink.vue
Any clarifications contact Divya

D:\Tvm\tv_primaryoffersites_client\src\Tv_PrimaryOffersites_Client\Velocity.PrimaryOffersites.Web\wwwroot\js\components\MegaMenu\MenuResearchModels\MenuResearchModels.vue
-->

<template>
  <div class="m-research-models-container">
    <div v-if="models && models.length" class="container">
      <div v-if="yearList && yearList.length > 1" class="row">
        <div class="col-12 text-center">
          <div class="years-list-wrapper d-inline-flex align-items-center justify-content-center">
            <div
              v-for="(year, yearIndex) in yearList" :key="yearIndex" class="year-selection ft-12 _theme_font_bold"
              :class="{'bgcolor-primary text-white': year === selectedYear}"
              @click="selectYear(year)"
            >
              {{ year }}
            </div>
          </div>
        </div>
      </div>
      <div class="row model-items-container">
        <div
          v-for="(model, index) in filterModels" :key="index" class="model-item-block col-6 col-xl-4 col-xxl-3"
        >
          <div class="model-item-content p-2 p-mb-3">
            <div v-if="model.model" class="model-item-name mb-1 text-center font-weight-bold _theme_font_bold" :style="{ 'min-height': modelHeadingHeight + 'px' }">
              {{ model.model }}
            </div>
            <div v-if="model.stockCount" class="model-stock-count ft-12 text-center">{{ model.stockCount }} available</div>
            <div class="text-center model-img-block">
              <v-lazy-image
                :src="frameUrl(model.imageUrl, 95)"
                :src-placeholder="frameUrl(model.imageUrl, 6)"
                class="img-fluid"
                :alt="getAltValue(model)"
              />
            </div>
            <div
              class="model-action-links d-flex align-items-center justify-content-between my-1"
            >
              <a v-if="model.inventoryUrl" :href="model.inventoryUrl" class="model-action-link">Inventory</a>
              <a v-if="model.navigationUrl" :href="model.navigationUrl" class="model-action-link text-center">Model Research</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { getMakeValue } from '../../../../../js/services/CommonUtility';

// won't support
import VLazyImage from "v-lazy-image";

export default {
  components: {
    VLazyImage
  },
  props: {
    setLoading:{
      type: Function,
      required: false,
      default: () => (status) => console.log(status),
    }
  },
  data(){
    return{
      isMobile: !!window?.ismobile,
      models:[],
      modelHeadingHeight: 0,
      useOverrides: window.digiServiceUseOverrides,
      yearList: [],
      selectedYear: "",
      filterModels: []
    }
  },
  async mounted() {
    await this.getModelsData();
    this.$nextTick(() => {
      this.calculateModelTitleHeight();
    });
  },
  methods:{
    async getModelsData() {
      try{
        this.setLoading(true);
         const response = await axios.get(
           `${window.ApiBaseUrl}/ResearchModel/make-models?make=${getMakeValue(window.themeName)}&dealerId=${window.accountId}&campaignId=${window.campaignId}`
          );
        if(response?.data) {
          this.models = response.data || [];
          this.yearList = [...new Set(this.models.map(({ year }) => year))].sort((a, b) => b - a);
          this.selectYear(this.yearList[0]);

        }else {
          console.log("No data returned from the API.");
        }
      }
      catch(error){
        console.log(error);
      }
      finally{
        console.log("finally block");
        this.setLoading(false);
      }
    },
    getAltValue(model){
      if(!model) return '';
      return `${model.year} ${model.make} ${model.model}`;
    },
    frameUrl(imgSrc, quality) {
      if (!imgSrc) return "";
      const baseUrl = `${imgSrc}&autocrop=true&angle=01&quality=${quality}&width=300`;
      if (!imgSrc.includes("service.secureoffersites.com")) {
        return imgSrc;
      }
      return this.useOverrides
      ? `${baseUrl}&useoverrides=${this.useOverrides}`
      : baseUrl;
    },
    calculateModelTitleHeight() {
      try {
        const headings = document.querySelectorAll(".model-item-name");
        let maxHeight = 0;
        if (headings?.length > 0) {
          headings.forEach(heading => {
            maxHeight = Math.max(maxHeight, heading.offsetHeight);
          });
          this.modelHeadingHeight = maxHeight;
        }
      } catch (err) {
        console.error("Error calculating heading height:", err);
      }
    },
    selectYear(year) {
      this.selectedYear = year;
      this.filterModels = this.models.filter((data) => data.year === year);
    },
  }
}
</script>

<style scoped>
.m-research-models-container {
  border-radius: 25px;
  background-color: #F3F3F3;
  overflow: scroll;
  padding: 24px;
}
.years-list-wrapper {
  border: 1px solid #ddd;
  border-radius: 25px;
  position: relative;
  top: -10px;
}
.year-selection {
  border-radius: 25px;
  padding: 5px 10px;
}

.model-item-content {
  max-width: 250px;
  margin: 0 auto;
}
.model-item-name {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.model-img-block {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.model-img-block img {
  max-height: 50px;
}
.model-action-links {
  gap: 10px;
}
.model-action-link {
  font-size: 12px;
  text-decoration: underline;
  color: #333;
}
.model-action-link:hover {
  color: inherit;
}
@media (max-width: 767px) {
  .m-research-models-container {
    padding: 24px 10px;
  }
}

@media (max-width: 1199px) {
  .model-items-container {
    gap: 16px
  }
  .model-item-block {
    flex: 0 0 calc(50% - 8px);
    max-width: calc(50% - 8px);
    border-radius: 15px;
    background-color: #fff;
  }
}
@media (min-width: 1200px) {
  .model-item-block {
    border-bottom: 1px solid #ddd;
    overflow: hidden;
    position: relative;
  }
  .model-item-block:hover {
    background-color: #fff;
    transition: all 0.5s ease;
  }
  .model-stock-count {
    position: relative;
    right: -100%;
    transition: all 0.5s ease;
    opacity: 0;
  }
  .model-item-block:hover .model-stock-count {
    opacity: 1;
    right: 50%;
    transform: translateX(50%);
  }

  .model-item-name {
    transform: translateY(50%);
    transition: all 0.5s ease;
  }
  .model-item-block:hover .model-item-name {
    transform: translateY(0%);
  }

  .model-action-links {
    opacity: 0;
    visibility: hidden;
    transform: translateY(50%);
    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s linear 0.3s;
    gap: 15px;
  }
  .model-item-block:hover .model-action-links {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
    transition: transform 0.3s ease, opacity 0.3s ease, visibility 0s;
  }
}
@media (min-width: 1400px) {
  .years-list-wrapper {
    top: -20px;
  }
}
@media(min-width: 2400px) {
  .model-item-name {
    font-size: 16px;
  }
  .model-stock-count {
    font-size: 14px;
  }
  .model-action-link {
    font-size: 14px;
  }
  .model-img-block {
    height: 80px;
  }
  .model-img-block img {
    max-height: 60px;
  }
}
</style>
